import { api_instance } from "./api";

export const costCalculator = (payload) => {
  return api_instance.post("/costCalculator.php", payload);
};
